<template>
  <header
    class="header-box"
    :class="{
      'header-box--small':!intro,
      'header-box--long':long,
      'header-box--no-margin':noMargin
    }"
  >
    <div class="header-box__innerwrap">
      <h1 class="header-box__title" v-html="title"></h1>
      <p v-if="intro" class="header-box__intro" v-html="intro"></p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header-box',
  props: {
    title: {
      type: String,
      required: true,
    },
    intro: {
      type: [String, Boolean],
      default: false,
    },
    long: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../scss/helpers.scss';

.header-box {
  color: $c_white;
  padding: 20px;
  background: $c_primary;
  box-sizing: border-box;

  @include not-mobile {
    padding: 40px;
  }

  @include landscape {
    padding: 20px;
  }

  &--small {
    padding: 35px 30px;
    width: calc(100% - 40px);
    margin: 20px 20px 0;

    @include not-mobile {
      width: calc(83.3333% - 66px);
      margin: 40px 0 0 40px;

      &.header-box--long {
        width: calc(100% - 80px);
      }
    }

    @include landscape {
      &.header-box--long {
        width: calc(50% - 30px);
        margin: 20px 20px 0;
      }
      width: calc(50% - 30px);
      margin: 20px 20px 0;
      padding: 30px;
    }
  }

  &--no-margin {
    margin: 0;
  }

  &--no-margin.header-box--long {
    width: 100%;
  }

  &__innerwrap {
    display: block;
    max-width: 920px;
    box-sizing: border-box;
    padding: 30px 30px 20px;

    @include not-mobile {
      padding: 40px;
    }

    @include landscape {
      padding: 30px 30px 20px;
    }
  }

  &--small &__innerwrap {
    padding: 0;
    max-width: none;
  }

  &__title {
    @include font-title;
  }

  &__intro {
    @include font-intro;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBox.vue